export const siteName = 'Vermont Roads';
export const baseApiPath = 'https://api.vermontroads.net/v1';
export const pdfBasePath = 'https://vermontroads.net/maps/';
export const pdfThumbBasePath = 'https://vermontroads.net/thumbs/';